import { Container, Grid } from '@material-ui/core'
import Carousel from 'react-material-ui-carousel'

interface Props {
  header: string
  testimonial: string
}

const TestimonialSlider = () => {
  const Testimonial = ({ header, testimonial }: Props) => {
    return (
      <Container className="slide" style={{ minHeight: 700 }}>
        <div className="content">
          <Grid container spacing={0}>
            <Grid item sm={12} md={8} lg={6}>
              <div className="accent"></div>
              <h2 className="m-b-25">{header}</h2>
              <p>{testimonial}</p>
            </Grid>
          </Grid>
        </div>
      </Container>
    )
  }

  return (
    <div className="carousel">
      <div
        className="background"
        style={{
          backgroundImage:
            "url('images/homepage/testimonials/testimonials-bg.jpg')",
        }}
      >
        <div className="overlay"> </div>

        <Carousel
          className="mui-carousel"
          IndicatorIcon={<div className="indicator"></div>}
          indicatorIconButtonProps={{
            style: {
              height: 2,
              width: 30,
              margin: '0 7.5px',
              padding: 0,
              background: '#a7a7a7',
              borderRadius: 0,
              marginTop: 3,
            },
          }}
          activeIndicatorIconButtonProps={{
            style: {
              height: 5,
              background: 'white',
              marginTop: 0,
            },
          }}
          interval={6000}
          navButtonsProps={{
            style: {
              opacity: 0.5,
              width: 48,
              height: 80,
              borderRadius: 0,
              margin: 0,
              background: 'black',
            },
          }}
        >
          <Testimonial
            header="Building robust programs"
            testimonial="“Our application required high dimensional precision with many complex GD&T callouts on the design. Hexagon Programming Services was able to interpret the ASME standards in order to select the best approach that would meet industry standards as well as our design intent. Additionally, Hexagon worked with us through the CMM verification and correlation processes, ensuring the programs were robust and meeting regulatory and company compliance. Through the entire process Hexagon Programming Services was always there to support and ensure success from beginning to end, always willing to help and going above and beyond.”"
          />
          <Testimonial
            header="Unblocking overloaded labs"
            testimonial="“We use Hexagon frequently to unblock our overloaded IQC labs. We also use Hexagon to run complex programs that we do not trust our less technically-savvy teams to run. Hexagon frequently helps us build programs that we then deploy to other sites once they are confirmed stable. [We have] dramatically reduced inspection times and have increased confidence in our inspection programs.”"
          />
          <Testimonial
            header="Cultivating deep partnerships"
            testimonial="“In the past 3 years, we have partnered with Hexagon to create products, improve features, and utilized contract programming as a service. We will continue to seek partners dedicated to fast paced, on point innovation to deliver the best outcomes for patients and success for our customers”"
          />
          <Testimonial
            header="Streamlining workflows"
            testimonial="“Contract services helps us fill internal skill gaps and streamline inspection programs to allow for consistent production flow. [Hexagon] has been an outstanding resource and support for our team.”"
          />
          <Testimonial
            header="Metrology assistance, wherever you need it"
            testimonial="“I would recommend Hexagon to anyone and everyone in need of Metrology assistance! They have helped us during inspection, new product launches, troubleshooting technical issues, and improved our PC-DMIS programming and program structure.”"
          />
        </Carousel>
      </div>
    </div>
  )
}

export default TestimonialSlider
